import React from 'react';

/* Crisp inline SVG icon set — replaces the old low-res webp icons. */
const base = { width: 22, height: 22, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' };

export const TelegramIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M21.94 4.6 18.7 19.4c-.24 1.08-.88 1.35-1.78.84l-4.92-3.63-2.37 2.28c-.26.26-.48.48-.99.48l.35-5.02 9.13-8.25c.4-.35-.09-.55-.61-.2l-11.29 7.1-4.86-1.52c-1.06-.33-1.08-1.06.22-1.57l19-7.33c.88-.33 1.65.2 1.43 1.74Z" fill="currentColor"/>
  </svg>
);

export const XIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M17.53 3h3.06l-6.69 7.64L21.75 21h-5.96l-4.67-6.1L5.77 21H2.7l7.15-8.17L2.25 3h6.11l4.22 5.58L17.53 3Zm-1.07 16.2h1.7L7.62 4.72H5.8L16.46 19.2Z" fill="currentColor"/>
  </svg>
);

export const MailIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Zm0 2v.4l8 5 8-5V7H4Zm16 2.5-7.4 4.6a1 1 0 0 1-1.2 0L4 9.5V17h16V9.5Z" fill="currentColor"/>
  </svg>
);

export const CopyIcon = (p) => (
  <svg {...base} width={18} height={18} {...p}>
    <path d="M9 3h9a2 2 0 0 1 2 2v11h-2V5H9V3Zm-4 4h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Zm0 2v10h9V9H5Z" fill="currentColor"/>
  </svg>
);

export const CheckIcon = (p) => (
  <svg {...base} width={18} height={18} {...p}>
    <path d="M9.55 17.6 4.4 12.4l1.4-1.4 3.75 3.75 8.25-8.25 1.4 1.42-9.65 9.68Z" fill="currentColor"/>
  </svg>
);

export const ArrowIcon = (p) => (
  <svg {...base} width={18} height={18} {...p}>
    <path d="M5 12h12.2l-4.6-4.6L14 6l7 7-7 7-1.4-1.4 4.6-4.6H5v-2Z" fill="currentColor"/>
  </svg>
);

export const FireIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M12 2c1 3-1.5 4.5-1.5 7 0 1.2.8 2 .8 2s-2.3-.6-2.3-3.2C7.3 9.2 6 11.4 6 14a6 6 0 0 0 12 0c0-3.6-2.6-6-3.6-8.2C13.6 4 12.8 2.8 12 2Z" fill="currentColor"/>
  </svg>
);

export const ChartIcon = (p) => (
  <svg {...base} width={18} height={18} {...p}>
    <path d="M3 3h2v16h16v2H3V3Zm5 10h2v4H8v-4Zm4-6h2v10h-2V7Zm4 3h2v7h-2v-7Z" fill="currentColor"/>
  </svg>
);
